import { createContext, useContext, useState, useEffect } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
const STORAGE_KEY = "nlc_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = (item) => {
    setItems((prev) => {
      if (prev.some((i) => i.key === item.key)) {
        toast.info("Déjà dans votre panier.", { description: item.name });
        return prev;
      }
      toast.success("Ajouté au panier.", { description: item.name });
      return [...prev, item];
    });
  };

  const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const replaceWith = (removeKeys, item) =>
    setItems((prev) => [...prev.filter((i) => !removeKeys.includes(i.key) && i.key !== item.key), item]);
  const clear = () => setItems([]);
  const has = (key) => items.some((i) => i.key === key);
  const total = items.reduce((s, i) => s + (i.price || 0), 0);

  return (
    <CartContext.Provider value={{ items, add, remove, replaceWith, clear, has, total, count: items.length }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
